const notificationIsDenied = async () => {
  if (!('Notification' in window)) {
    return true;
  }
  if (Notification.permission === 'denied') {
    return true;
  }
  if (Notification.permission === 'default') {
    return await Notification.requestPermission().then((permission) => permission === 'denied');
  }
  return false;
};

const popNotification = (title: string, options: NotificationOptions) => {
  const notification = new Notification(title, options);
};

export const notifyDeviceAdded = async (deviceName: string) => {
  if (await notificationIsDenied()) { return; }
  const title: string = 'device added';
  const options: NotificationOptions = {
    body: deviceName,
  };
  popNotification(title, options);
};

export const notifyDeviceDeath = async (deviceName: string) => {
  if (await notificationIsDenied()) { return; }
  const title: string = 'Device died';
  const options: NotificationOptions = {
    body: deviceName,
  };
  popNotification(title, options);
};

export const notifyDeviceRevival = async (deviceName: string) => {
  if (await notificationIsDenied()) { return; }
  const title: string = 'Device revived';
  const options: NotificationOptions = {
    body: deviceName,
  };
  popNotification(title, options);
};
